
import { toast as sonnerToast } from 'sonner';

// Re-export the toast from sonner
export const toast = sonnerToast;

// Create a hook that returns the toast function
export const useToast = () => {
  return { toast: sonnerToast };
};
